import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useDefinitions() {
  const { state } = useLocation()
  const { sweepId } = state || {}

  const filters = useMemo(() => sweepId ? { sweepId: [sweepId] } : {}, [sweepId])

  return useMemo(() => ({
    entityName: 'Contest',
    entityNamePlural: 'Contests',
    entityNameModule: 'cms',
    basePath: `/cms/sweep/contests`,
    filters,
  }), [filters])
}
